import React, { useMemo } from 'react';
import { CaseTag } from '../../../../graphql/graphql';
import { joinClasses } from '../../../../Utils/className.util';
import styles from './CaseTagBadge.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	caseTag: CaseTag;
}

const CaseTagBadge: React.FC<Props> = ({ caseTag }) => {
	const tagSettings: { title: string; theme: Theme } | undefined =
		useMemo(() => {
			if (caseTag === CaseTag.ClinicalMonitoring) {
				return {
					theme: Theme.RED,
					title: 'base.clinicalMonitoring',
				};
			}
			return undefined;
		}, [caseTag]);

	if (!tagSettings) return <></>;

	return (
		<Text
			tx={tagSettings.title}
			className={joinClasses([styles.wrapper, styles[tagSettings.theme]])}
		/>
	);
};

export default CaseTagBadge;
